import React, { useState, useCallback, useRef, useEffect } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadPanel } from 'devextreme-react/load-panel';
import SearchResult from "./LocationTrackingSearchResult";
import { GetSearchLocationQuantitySummary } from "../../../services/LocationService"
import SearchFormLayout from './SearchFormLayout';
import FormField from '../../../dynamicFormBuilder/FormField';
import AdjustAvailableUnAvailableStatusPopup from "./AdjustAvailableUnAvailableStatusPopup";
import { Button } from 'devextreme-react/button';
import data from "../../../assets/apiRoutes.json";

const panel = [
    {
        ID: 1,
        Title: 'Create Datasource'
    }
];
const AdjustAvailableUnAvailableStatus = (props) => {
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    // Visibility and the rows live in ONE state object on purpose. openPopup is invoked from a
    // DevExtreme onClick, which is not a React synthetic event, so React 17 does not batch separate
    // setState calls there — two calls meant two renders, the popup mounting on the first with the
    // previous selection and its [selectedRows] effect re-firing on the second. That fetched
    // GetReasonComments / GetReasonsCodes / GetLocationQuantitySummaryByRowIds twice per open.
    const [statusPopup, setStatusPopup] = useState({ visible: false, rows: [] });
    const initialFormFields = {
        Item: '',
        ItemDescription: '',
        Lot: '',
        LotDescription: '',
        location: '',
        LocationDescription: '',
        Warehouse: '',
        Unit: '',
        Sublot: '',
        Customer: '',
        InTransactionNumber: '',
    };
    const handleReset = () => {
        setformFields(initialFormFields);
    };
    const handleFieldChange = useCallback((name, value) => {
        console.log(name, value)

    }, []);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const handleSalesOrderSearchFormLoad = useCallback(() => {
    }, []);
    const [formFields, setformFields] = useState(initialFormFields);
    const formRefs = useRef({});
    const [dataSource, setDataSource] = useState(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const gridKey = "6a4a2946-680f-4925-9af3-bbde3f8aa222";
    const detailDataGrid = useRef(null);
    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    const url = data.LocationTracking.SearchLocationQuantitySummary;
    const searchData = (formFields) => {
        var resultData = GetSearchLocationQuantitySummary(accessToken, url, formFields);
        setDataSource(resultData);
    };
    // Handle the result grid exposes, so the sequence below stays explicit and ordered.
    const gridActions = useRef({});
    // Delphi ShowDataSelector order: unselect the rows, reset the two totals, then reload.
    const resetSelectionAndSearch = (fields) => {
        // Plain if, not `?.()` — an optional call as a bare statement trips no-unused-expressions.
        const clearSelectionAndResetTotals = gridActions.current.clearSelectionAndResetTotals;
        if (clearSelectionAndResetTotals) {
            clearSelectionAndResetTotals();
        }
        searchData(fields);
    };
    const openPopup = (selectedRowsData) => {
        setStatusPopup({ visible: true, rows: selectedRowsData || [] });
    };

    useEffect(() => {
        searchData(formFields);
    }, []);
    const handleFormSubmit = () => {
        resetSelectionAndSearch(formFields);
    };
    return (
        <div>
            <div className="row" style={{ marginLeft: "2px" }}>
                <div className="col-md-12" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                    <div id="accordion" >
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={showIndicator}
                            shading={shading}
                            showPane={showPane}
                            hideOnOutsideClick={hideOnOutsideClick}
                        />
                            <AccordionReact
                                dataSource={panel}
                                collapsible={true}
                                multiple={false}
                                animationDuration={300}
                                selectedItems={selectedItems}
                                onSelectionChanged={e => {
                                    if (e.currentTarget === e.target) {
                                        selectionChanged(e, e.target);
                                    }
                                }}
                                itemTitleRender={() => (
                                    <Toolbar className="accordian-toolbar">
                                        <Item location="before">
                                            <div className="title">
                                                <h6
                                                    style={{
                                                        color: window._env_.Color2
                                                    }}
                                                >
                                                   Search Adjust Available Unavailable Status
                                                </h6>
                                            </div>
                                        </Item>
                                        <Item location="after">
                                            <Button className="gridTopButton" text="Search" onClick={handleFormSubmit} type="default"></Button>
                                        </Item>
                                        <Item location="after">
                                            <Button className="gridTopButton" onClick={(e) => handleReset()} text="Reset" />
                                        </Item>
                                    </Toolbar>
                                )}
                                itemRender={(itemProps) => (
                                    <div >
                                        <FormField
                                            currrentUser={currentUser}
                                            layoutId='E4775B5D-9133-4DDB-8300-058CE6AC092D'
                                            layoutName='MyTestForm'
                                            defaultFormSchema={SearchFormLayout}
                                            formFields={formFields}
                                            setformFields={setformFields}
                                            handleFieldValueChange={handleFieldChange}
                                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                            formRefs={formRefs}
                                            onFormLoad={handleSalesOrderSearchFormLoad}
                                            noSpacingBeforeFirstRow={true}
                                        />

                                    </div>
                                )}
                                id="accordion-container"
                            />
                    </div>
                </div>
            </div>
            <div>
                <SearchResult data={dataSource} searchPanelStatus={searchPanelStatus}
                    openPopup={openPopup}
                    gridActions={gridActions}
                />
                {statusPopup.visible && (
                    <AdjustAvailableUnAvailableStatusPopup
                        visible={statusPopup.visible}
                        selectedRows={statusPopup.rows}
                        accessToken={accessToken}
                        onClose={() => {
                            resetSelectionAndSearch(formFields);
                            setStatusPopup({ visible: false, rows: [] });
                        }}
                    />
                )}
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AdjustAvailableUnAvailableStatus);
